import { Controller } from "@hotwired/stimulus"

// Employer picker controller for selecting multiple employers:
// - Select from dropdown adds a pill (with its own hidden input)
// - Removing the pill removes the input (remove-element controller)
// - De-dupe based on existing hidden inputs
//
// Follows the pattern of preferred_provider_rule_picker_controller
export default class extends Controller {
  static targets = [
    "selectField",
    "pillTemplate",
    "pills"
  ]

  addFromSelect() {
    const select = this.selectFieldTarget
    const selectedOption = select.options[select.selectedIndex]

    if (!selectedOption || !selectedOption.value) return

    const value = selectedOption.value
    const label = selectedOption.text

    // De-dupe
    if (this.pillValues().includes(value)) {
      this.clearSelection()
      return
    }

    const pillId = `employer-pill-${Date.now()}-${Math.random().toString(16).slice(2)}`

    const templateRoot = this.pillTemplateTarget?.content?.firstElementChild
    if (!templateRoot) return

    const wrapper = templateRoot.cloneNode(true)
    wrapper.id = pillId
    wrapper.dataset.employerValue = value

    const hiddenInput = wrapper.querySelector('input[type="hidden"]')
    if (hiddenInput) hiddenInput.value = value

    const labelEl = wrapper.querySelector("[data-pill-label]")
    if (labelEl) labelEl.textContent = label

    const removeButton = wrapper.querySelector('[data-controller="remove-element"]')
    if (removeButton) {
      removeButton.dataset.elementId = pillId
      removeButton.setAttribute("aria-label", `Remove ${label}`)
    }

    this.pillsTarget.appendChild(wrapper)
    this.clearSelection()
  }

  pillValues() {
    const templateRoot = this.pillTemplateTarget?.content?.firstElementChild
    const templateHiddenInput = templateRoot?.querySelector('input[type="hidden"]')
    const inputName = templateHiddenInput?.getAttribute("name")
    if (!inputName) return []

    return Array.from(this.pillsTarget.querySelectorAll(`input[name="${CSS.escape(inputName)}"]`))
      .map((el) => (el.value || "").trim())
      .filter((v) => v.length > 0)
  }

  clearSelection() {
    this.selectFieldTarget.selectedIndex = 0
  }
}
